import './index.scss';

import { Component, DetailedHTMLProps, TableHTMLAttributes } from 'react';

export type BraxTableProps = DetailedHTMLProps<TableHTMLAttributes<HTMLTableElement>, HTMLTableElement>;

export class BraxTable extends Component<BraxTableProps> {

    render() {
        const { className, ...props } = this.props;

        return (
            <table className={`brax-table ${className || ''}`} {...props} />
        );
    }

}
